var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-body error-container"},[_c('div',{staticClass:"case orange-gradient"},[_c('p',[_vm._v("Oops !")]),_vm._v(" "),(_vm.error.trim() != '')?_c('p',[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.apiError.trim() != '')?_c('p',[_vm._v(_vm._s(_vm.apiError))]):_c('p',[_vm._v("One error occured")])]),_vm._v(" "),_c('i',{staticClass:"image fa fa-search"}),_vm._v(" "),_c('app-scan-another-code')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a187a72","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Error.vue
// module id = 97
// module chunks = 0